import ToggleButtonGroup, {
    toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';
import { Route, Routes } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { selectedOperationState } from '~/state/atoms/toolsAtoms';
import { SliceClearingOperation } from './slice-clearing-operation';

const operations = [SliceClearingOperation];

export default function Operations() {
    const [operation] = useRecoilState(selectedOperationState);

    return (
        <ToggleButtonGroup
            value={operation}
            exclusive
            sx={(theme) => ({
                [`&.${toggleButtonGroupClasses.root}:not(:last-child)`]: {
                    columnGap: theme.spacing(1),
                },
            })}
        >
            <Routes>
                <Route
                    path="contour/*"
                    element={
                        <>
                            {operations.map((Operation, index) => (
                                <Operation key={index} />
                            ))}
                        </>
                    }
                />
                <Route path="dose/*" element={null} />
                <Route
                    path="*"
                    element={
                        <>
                            {operations.map((Operation, index) => (
                                <Operation key={index} />
                            ))}
                        </>
                    }
                />
            </Routes>
        </ToggleButtonGroup>
    );
}
